__turbopack_context__.v({
  "large": "loader-module-scss-module__D2XPma__large",
  "loader": "loader-module-scss-module__D2XPma__loader",
  "medium": "loader-module-scss-module__D2XPma__medium",
  "small": "loader-module-scss-module__D2XPma__small",
  "tiny": "loader-module-scss-module__D2XPma__tiny",
});
